import { Base } from "@studiometa/js-toolkit";
import { domScheduler, wait } from "@studiometa/js-toolkit/utils";
import HeaderSwitcher from "./HeaderSwitcher.js";
import LayoutReactive from "./LayoutReactive.js";
import LayoutSwitcher from "./LayoutSwitcher.js";
import ThemeSwitcher from "./ThemeSwitcher.js";
import EditorVisibility from "./EditorVisibility.js";
import Editors from "./Editors.js";
import Iframe from "./Iframe.js";
import { layoutUpdateDOM, themeUpdateDOM, headerUpdateDOM } from "../store/index.js";
import { urlStore } from "../utils/storage/index.js";
import { setDefaults } from "../store/config.js";
layoutUpdateDOM();
themeUpdateDOM();
headerUpdateDOM();
class Playground extends Base {
  static config = {
    name: "Playground",
    refs: ["htmlVisibility", "scriptVisibility", "styleVisibility"],
    options: {
      html: String,
      style: String,
      script: String
    },
    components: {
      LayoutReactive,
      LayoutSwitcher,
      ThemeSwitcher,
      HeaderSwitcher,
      EditorVisibility,
      Editors,
      Iframe,
      Resizable: async () => wait(100).then(() => import("./Resizable.js")),
      HtmlEditor: async () => wait(100).then(() => import("./HtmlEditor.js")),
      ScriptEditor: async () => wait(100).then(() => import("./ScriptEditor.js")),
      StyleEditor: async () => wait(100).then(() => import("./StyleEditor.js")),
      IframeReloader: async () => wait(100).then(() => import("./IframeReloader.js"))
    }
  };
  get iframe() {
    return this.$children.Iframe[0];
  }
  get editors() {
    return this.$children.Editors[0];
  }
  get htmlEditorVisibility() {
    for (const editor of this.$children.EditorVisibility) {
      if (editor.$el.dataset.lang === "text/html") {
        return editor;
      }
    }
  }
  get scriptEditorVisibility() {
    for (const editor of this.$children.EditorVisibility) {
      if (editor.$el.dataset.lang === "text/javascript") {
        return editor;
      }
    }
  }
  get styleEditorVisibility() {
    for (const editor of this.$children.EditorVisibility) {
      if (editor.$el.dataset.lang === "text/css") {
        return editor;
      }
    }
  }
  async mounted() {
    setDefaults({
      html: this.$options.html,
      script: this.$options.script,
      style: this.$options.style
    });
    this.$refs.htmlVisibility.checked = !await urlStore.has("html-editor") || await urlStore.get("html-editor") === "true";
    this.$refs.styleVisibility.checked = !await urlStore.has("style-editor") || await urlStore.get("style-editor") === "true";
    this.$refs.scriptVisibility.checked = !await urlStore.has("script-editor") || await urlStore.get("script-editor") === "true";
    this.htmlEditorVisibility.toggle(this.$refs.htmlVisibility.checked);
    this.scriptEditorVisibility.toggle(this.$refs.scriptVisibility.checked);
    this.styleEditorVisibility.toggle(this.$refs.styleVisibility.checked);
    this.maybeToggleEditorsContainer();
  }
  onHtmlVisibilityInput({ target: { checked } }) {
    this.htmlEditorVisibility.toggle(checked);
    urlStore.set("html-editor", checked);
    this.maybeToggleEditorsContainer();
  }
  onStyleVisibilityInput({ target: { checked } }) {
    this.styleEditorVisibility.toggle(this.$refs.styleVisibility.checked);
    urlStore.set("style-editor", checked);
    this.maybeToggleEditorsContainer();
  }
  onScriptVisibilityInput({ target: { checked } }) {
    this.scriptEditorVisibility.toggle(this.$refs.scriptVisibility.checked);
    urlStore.set("script-editor", checked);
    this.maybeToggleEditorsContainer();
  }
  maybeToggleEditorsContainer() {
    const { editors } = this;
    if (!this.$refs.htmlVisibility.checked && !this.$refs.scriptVisibility.checked && !this.$refs.styleVisibility.checked) {
      editors.hide();
    } else {
      editors.show();
    }
  }
  onHtmlEditorContentChange() {
    this.iframe.updateHtml();
  }
  onStyleEditorContentChange() {
    this.iframe.updateStyle();
  }
  onScriptEditorContentChange() {
    this.iframe.updateScript();
  }
  onResizableDragged(props) {
    const { iframe } = this;
    if (props.mode === "start") {
      domScheduler.write(() => {
        document.body.classList.add("select-none");
        iframe.$el.parentElement.classList.add("pointer-events-none");
      });
    }
    if (props.mode === "drop") {
      domScheduler.write(() => {
        document.body.classList.remove("select-none");
        iframe.$el.parentElement.classList.remove("pointer-events-none");
      });
    }
  }
  async onIframeReloaderClick() {
    this.iframe.initIframe();
  }
}
export {
  Playground
};
//# sourceMappingURL=Playground.js.map
